import i18n from '@/plugins/i18n.js'
import publicRoutes from '@/router/routes/public.routes'
import videoRoutes from '@/router/routes/video.routes'
import professionalRoutes from '@/router/routes/webapp/professional.routes'
import patientRoutes from '@/router/routes/webapp/patient.routes'
import routeHelpers from '@/router/routeHelpers'
import testingRoutes from '@/router/routes/testing.routes'
import primesaludRoutes from '@/router/routes/opensaludprime.routes'
import opensalud4all from '@/router/routes/opensalud4all.routes'
import openlegalRoutes from '@/router/routes/openlegal.routes'
import abogalityproRoutes from '@/router/routes/abogalitypro.routes'
import unipromelRoutes from '@/router/routes/unipromel.routes'
import accountRoutes from '@/router/routes/account.routes'
import forumRoutes from '@/router/routes/webapp/forum.routes'
import healthyCommunityRoutes from '@/router/routes/webapp/healthycommunity.routes'
import healthyHabitsRoutes from '@/router/routes/webapp/healthyhabits.routes'
import opensalud360Routes from '@/router/routes/opensalud360.routes'
import surveyRoutes from '@/router/routes/webapp/survey.routes'
import { OPENSALUD_PACIENTES_LAYOUT } from '@/constants/layouts'
import { inMx } from '@/helpers/global.helpers'
import { OPENSALUD_LOGO, OPENSALUD_MX_LOGO, OPENSALUD_WHITE_LOGO, OPENSALUD_MX_WHITE_LOGO } from '@/constants/logosFileNames'
import { isMobileOrTablet } from '@/helpers/ui.helpers'

let mixedPublicRoutes = publicRoutes

if (process.env.NODE_ENV !== 'production') {
  mixedPublicRoutes = publicRoutes.concat(testingRoutes)
}

const baseRoutes = [
  ...[
    	{
				path: '/',
				name: 'Pacientes',
				component: () => import('@/components/views/opensalud/Pacientes'),
				meta: {
					layout: OPENSALUD_PACIENTES_LAYOUT,
					title: {
						text () {
							return i18n.t('patient-title')
						},
					},
					logo: {
						src: inMx ? (isMobileOrTablet ? OPENSALUD_MX_WHITE_LOGO : OPENSALUD_MX_LOGO) : (isMobileOrTablet ? OPENSALUD_WHITE_LOGO : OPENSALUD_LOGO),
					},
					tagLine: false,
					i18n: 'public/views/opensalud-pacientes.json'
				},
			},
  ],
  ...mixedPublicRoutes
]

const children = [
  {
    path: '',
    component: () => import('@/components/public/OpensaludLanding')
  },
  routeHelpers.buildRoutes('patient', patientRoutes),
  routeHelpers.buildRoutes('professional', professionalRoutes),
  routeHelpers.buildRoutes('center', []),
  routeHelpers.buildRoutes('video', videoRoutes, () => import('@/components/video-launcher/VideoLayout')),
  routeHelpers.buildRoutes('opensaludprime', primesaludRoutes),
  routeHelpers.buildRoutes('openlegal', openlegalRoutes),
  routeHelpers.buildRoutes('opensalud4all', opensalud4all),
  routeHelpers.buildRoutes('abogalitypro', abogalityproRoutes),
  routeHelpers.buildRoutes('unipromel', unipromelRoutes),
  routeHelpers.buildRoutes('cuenta', accountRoutes),
  routeHelpers.buildRoutes('foro', forumRoutes),
  routeHelpers.buildRoutes('comunidadsaludable', healthyCommunityRoutes),
  routeHelpers.buildRoutes('habitossaludables', healthyHabitsRoutes),
  routeHelpers.buildRoutes('360', opensalud360Routes),
  routeHelpers.buildRoutes('survey', surveyRoutes)
]

const routes = [...baseRoutes, ...children]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes/webapp/routes.js